<template>
    <div>
        <div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <app-tabela
                idTabela="tblContratos"
                :itens="contratosIndice"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
                <template slot="vigencia" slot-scope="data">
                    {{
                        data.dtInicioVigencia
                            ? $moment(data.dtInicioVigencia).format(
                                  'DD/MM/YYYY'
                              )
                            : ''
                    }}
                    <span v-if="data.dtInicioVigencia">a</span>
                    {{
                        data.dtFimVigencia
                            ? $moment(data.dtFimVigencia).format('DD/MM/YYYY')
                            : ''
                    }}
                </template>
                <template slot="isAditivo" slot-scope="data">
                    <app-status
                        :status="data.isAditivo ? 'SIM' : 'NÃO'"
                    ></app-status>
                </template>
                <template slot="contratoVigente" slot-scope="data">
                    <app-status
                        :status="data.contratoVigente ? 'SIM' : 'NÃO'"
                    ></app-status>
                </template>
                <template slot="nuValorGlobalContrato" slot-scope="data">
                    {{ data.nuValorGlobalContrato | currency }}
                </template>
                <template slot="acoes" slot-scope="data">
                    <span
                        class="text-primary mr-1"
                        v-if="permiteDetalhar"
                    >
                        <i
                            class="fa fa-info-circle fa-lg icon-button"
                            title="Detalhar"
                            @click.stop="detalharContrato(data.idContrato)"
                        ></i>
                    </span>
                </template>
            </app-tabela>
        </div>
    </div>
</template>

<script>

export default {
    components: {},

    props: {
        contrato: {
            type: Object,
            default: () => {}
        },

        servicos: {
            type: Object
        },

        permiteDetalhar: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            erros: [],
            contratos: [],
            campos: [
                {
                    key: 'index',
                    label: 'Nº',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'vcCodigoEstruturado',
                    label: 'Contrato',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'vcObjetoContrato',
                    label: 'Objeto',
                    filterable: true,
                    tdClass: 'colObjeto'
                },
                {
                    key: 'vigencia',
                    label: 'Vigência',
                    tdClass: 'text-center'
                },
                {
                    key: 'nuValorGlobalContrato',
                    label: 'Valor Total',
                    tdClass: 'text-right text-nowrap'
                },
                {
                    key: 'isAditivo',
                    label: 'Aditivo',
                    tdClass: 'text-center'
                },
                {
                    key: 'tiposAditivo',
                    label: 'Tipos do Aditivo'
                },
                {
                    key: 'contratoVigente',
                    label: 'Vigente',
                    tdClass: 'text-center'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5
        }
    },
    methods: {
        obterHistoricoAditivo() {
            this.$store.dispatch('addRequest')
            this.servicos.obterHistoricoAditivos(this.contrato.idContrato).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.contratosOrder(response.data)
                        } else {
                            this.$toast.error(
                                response.errors,
                                'ERROR',
                                this.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        detalharContrato(id) {
            if (this.$route.params.contratoId != id) {
                this.$emit('obterContrato', id)
            } else {
                this.$toast.success(
                    'Contrato/Aditivo já selecionado!',
                    '',
                    this.$toastConfig.success
                )
            }
        },

        contratosOrder(contratos) {
            this.contratos = contratos.sort(
                (a, b) => b.dtFimVigencia - a.dtFimVigencia
            )
            this.contratos.reverse()
        }
    },

    created() {
        this.obterHistoricoAditivo(this.contrato)
    },

    computed: {
        contratosIndice() {
            return this.contratos.map((contratos, index) => ({
                ...contratos,
                index: index + 1
            }))
        }
    },

    watch: {}
}
</script>
